import AppContext from '../../AppContext';

import Countdown, { zeroPad } from 'react-countdown';

import './Page.css';

import { Crisp } from "crisp-sdk-web";

import { useContext, useState } from 'react';
import { useEffect } from 'react';

import { useNavigate, useSearchParams } from "react-router-dom";

import axios from 'axios';
import USPs from './USPs';
import Schema from './Schema';
import Wetenschap from './Wetenschap';
import ReviewsList from './ReviewsList';
import OfferPakket from './OfferPakket';
import OfferCard from './OfferPakketCard';
import Gifts from './Gifts';
import Insta from './Instagram';
import Header from './Header';
import Intro from './Intro';
import Resultaten from './Resultaten';
import StickyAtc from './StickyAtc';
import FeaturedReview from './FeaturedReview';
import JouwCoach from './JouwCoach';
import Traject from './Traject';
import Verwachten from './Verwachten';
import VoorWie from './VoorWie';
import VoorWieNieuw from './VoorWieNieuw';
import NietVoorJou from './NietVoorJou';
import WatMoetIkLaten from './WatMoetIkLaten';
import Garantie from './Garantie';
import Twijfels from './Twijfels';
import WatNodig from './WatNodig';
import DeChallenge from './DeChallenge';
import Waarom from './Waarom';
import TextImage from './TextImage';
import HeaderReview from './HeaderReview';
import OfferItems from './OfferItems';
import Facebook from './Facebook'; 
import WatJeKrijgt from './WatJeKrijgt';
import Cta from '../Namaak/Cta';
import Stappenplan from './Stappenplan';
import DeApp from './DeApp';
import FitnessQuiz from './QuizApp';
import ReviewsSection from './ReviewsSection';

function GoedeVoornemens({ defaultPrice }) {

  Crisp.configure('3a766b7e-34c5-4cea-8d7c-8b42d4bb1ed6', {
    autoload: false
  });

  useEffect(() => {
    Crisp.load();
  }, [])

  // Track page visit on component mount
  useEffect(() => {
    const trackPageVisit = async () => {
      try {
        await fetch('https://hook.eu2.make.com/gtmbqn4i2y6lq6dyut1x3bcl4tkyrwn6', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            event: 'page_visited',
            timestamp: new Date().toISOString(),
            page: 'GoedeVoornemens',
            url: window.location.href,
            referrer: document.referrer || 'direct'
          })
        });
        console.log('Page visit tracked successfully');
      } catch (error) {
        console.error('Failed to track page visit:', error);
      }
    };

    if (!window.location.hostname.includes('ngrok')) {
      trackPageVisit();
    }
  }, []); // Empty dependency array ensures this runs once on mount
  
  const { globalState, updateGlobalState } = useContext(AppContext);

  var today = new Date();
  today.setHours(today.getHours() + 4);

  // Renderer callback with condition
  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return false;
    } else {
      // Render a countdown
      return (
        <div className="timer" style={{ display: 'flex' }}>
          {/* <div className="timer-desc">
            <span style={{ whiteSpace: "nowrap" }}>ik zoek nog</span>
          </div> */}
          {/* <div className="timer-box">
            <span>2</span>
          </div> */}
          {/* <div className="timer-desc">
            <span>klanten</span>
          </div> */}
          <div className="timer-box">
            <span>{ zeroPad(days) }</span>
            <span>dagen</span>
          </div>
          <div className="timer-box">
            <span>{ zeroPad(hours) }</span>
            <span>uren</span>
          </div>
          <div className="timer-box">
            <span>{ zeroPad(minutes) }</span>
            <span>minuten</span>
          </div>
          <div className="timer-box">
            <span>{ zeroPad(seconds) }</span>
            <span>seconden</span>
          </div>
        </div>
      );
    }
  };
  
  const [searchParams, setSearchParams] = useSearchParams();

  const navigate = useNavigate();

  const [activeFaq, setActiveFaq] = useState(0);
  const faqs = [
    {
      "vraag": "Is dit programma geschikt voor beginners?",
      "antwoord": "Ja! Of je nu net begint of al jaren traint, jouw trainingsplan wordt volledig afgestemd op jouw niveau en doelen. Beginners leren de juiste technieken voor hun persoonlijke situatie, terwijl gevorderden hun progressie kunnen versnellen."
    },
    {
      "vraag": "Hoeveel tijd kost dit per week?",
      "antwoord": "Dat bepaal je zelf! Jij geeft aan hoeveel dagen je beschikbaar bent en hoe lang je wilt trainen (bijvoorbeeld 30, 45 of 60 minuten per sessie). Ik pas je schema daarop aan, zodat het perfect in jouw agenda past."
    },
    {
      "vraag": "Wat gebeurt er na de eerste 4 weken?",
      "antwoord": "Na de eerste 4 weken kun je ervoor kiezen om door te gaan met mijn begeleiding voor slechts €29 per maand. Je schema wordt wekelijks aangepast op jouw voortgang. Als je niet verder wilt, heb je nog steeds een plan en kennis die je zelfstandig kunt blijven gebruiken."
    },
    {
      "vraag": "Wat als ik vragen heb of een oefening niet begrijp?",
      "antwoord": "Je kunt altijd contact opnemen met mij, jouw coach, via de app. Bovendien zijn alle oefeningen voorzien van duidelijke voorbeeldvideo's, zodat je altijd weet wat je moet doen."
    },
    {
      "vraag": "Hoe weet ik dat dit programma werkt voor mij?",
      "antwoord": "Jouw trainingsplan wordt volledig gepersonaliseerd. Jouw intakeformulier bepaalt hoe jouw schema eruitziet, zodat het specifiek is afgestemd op jouw doelen, niveau en beschikbaarheid. Ik gebruik bewezen methodes die werken voor iedereen – of je nu wilt aankomen in spiermassa, sterker wilt worden, of gewoon een plan nodig hebt dat écht werkt."
    },
    {
      "vraag": "Moet ik toegang hebben tot een sportschool?",
      "antwoord": "Hoewel het programma ideaal is voor gebruik in de sportschool, kan ik ook een schema maken dat je thuis kunt volgen. Geef in je intake aan wat voor apparatuur je tot je beschikking hebt, en ik ontwerp een plan dat daarbij past."
    },
    {
      "vraag": "Hoe snel zie ik resultaten?",
      "antwoord": "De meeste klanten merken na de eerste 2-3 weken al verbetering in kracht, uithoudingsvermogen en spierdefinitie. Na 4 weken zie je duidelijk verschil – zowel fysiek als mentaal. Het exacte tempo hangt af van je startniveau, doelen en consistentie."
    },
    {
      "vraag": "Wat maakt dit anders dan andere apps of schema's?",
      "antwoord": "In tegenstelling tot standaard apps of statische schema's, is mijn programma volledig gepersonaliseerd én dynamisch. Dat betekent dat jouw schema wekelijks wordt aangepast op jouw voortgang. Bovendien heb je altijd een coach om vragen aan te stellen en je te begeleiden."
    },
    {
      "vraag": "Wat als ik mijn schema niet haal?",
      "antwoord": "Geen probleem! Ik begrijp dat het leven soms druk kan zijn. Geef aan wat er speelt, en ik pas je schema aan zodat het haalbaar blijft. Consistentie is belangrijker dan perfectie."
    },
    {
      "vraag": "Is er een garantie dat ik resultaat zie?",
      "antwoord": "Hoewel resultaat afhankelijk is van jouw inzet en consistentie, garandeer ik dat je na 4 weken de kennis en tools hebt om vooruitgang te boeken. Mijn klanten zien vrijwel altijd verbetering in kracht, spiermassa en zelfvertrouwen. Wanneer je écht niet blij bent met je behaalde resultaten, dan bied ik een 100% geld-terug-garantie."
    }
  ];

  const [activeObjection, setActiveObjection] = useState(0); 
  const objectionHandlers = [
    {
      "vraag": "\"Ik heb al eerder geprobeerd om spiermassa op te bouwen, maar het lukte me niet. Waarom zou het deze keer anders zijn?\"",
      "antwoord": "Dat begrijp ik. Deze challenge biedt echter persoonlijke begeleiding en op maat gemaakte trainingsschema's die specifiek zijn ontworpen om jou te helpen jouw doelen te bereiken. Met de juiste begeleiding en ondersteuning is succes binnen handbereik."
    },
    {
      "vraag": "\"Ik ben niet zeker of ik genoeg tijd heb om me volledig aan de challenge te wijden. Hoe kan ik er zeker van zijn dat ik mijn schema kan volgen?\"",
      "antwoord": "We begrijpen dat het leven druk kan zijn, maar de trainingsschema's zijn flexibel en kunnen worden aangepast aan jouw schema. Onze coaches zullen je helpen om realistische doelen te stellen en je ondersteunen bij het vinden van manieren om de challenge in je drukke leven te passen."
    },
    {
      "vraag": "\"Ik heb geen ervaring met krachttraining. Is deze challenge geschikt voor beginners?\"",
      "antwoord": "Absoluut! Deze challenge is ontworpen voor mensen van alle fitnessniveaus, inclusief beginners. Onze coaches zullen je begeleiden bij elke stap van je fitnessreis en ervoor zorgen dat je de juiste technieken leert en veilig vooruitgang boekt."
    },
    {
      "vraag": "\"Ik ben bang dat ik mijn voortgang niet zal kunnen bijhouden of dat ik niet gemotiveerd genoeg zal zijn om door te zetten. Hoe kan ik hiermee omgaan?\"",
      "antwoord": "Het is normaal om af en toe twijfels te hebben, maar we zijn hier om je te ondersteunen. Onze challenge omvat regelmatige voortgangsbeoordelingen en persoonlijke begeleiding om je gemotiveerd te houden en eventuele obstakels te overwinnen. Samen zullen we jouw succes verzekeren."
    }
  ]
  
  return (
    <>
      {/* <StickyAtc defaultPrice={defaultPrice} /> */}

      <HeaderReview />
      {/* <ReviewsSection /> */}

      {/* <USPs />  */}

      {/* <FitnessQuiz /> */}

      {/* <VoorWieNieuw /> */}
    </>
  )
}

export default GoedeVoornemens;